import React, { Component } from 'react';
import { Link } from "react-router-dom";

import config from './../config';

class FacebookSocialPlugin extends Component {
	constructor(props) {
		super(props);

		this.state = {
			initialized: false
		};
	}

	componentDidMount() {
		if (!this.props.manualInit) {
			setTimeout(function() {
				this.initialize();
			}.bind(this), 50);
		}
	}

	initialize() {
		if (this.initialized) {
			return;
		}

		let fbInit = function() {
			try {
				if (window.FB) {
					window.FB.XFBML.parse();

					this.initialized = true;


					setTimeout(function() {
						this.setState({
							initialized: true
						});
					}.bind(this), 100);
				}
			}
			catch (e) {
				setTimeout(fbInit, 2000);
			}
		}.bind(this);

		fbInit();
	}

	render() {
		let fbEl = this.props.type == 'comments' ?
			<div className={'fb-comments'} data-href={this.props.url} data-width="500" data-numposts="20"></div> :
		this.props.type == 'likes' ?
			<div className={'fb-like'} data-href="{this.props.url}" data-layout="button_count" data-action="like" data-size="large" data-show-faces="false" data-share="false"></div> :
		<span />;

		return (
			fbEl
		);
	}
}

export default FacebookSocialPlugin;



// WEBPACK FOOTER //
// ./src/components/FacebookSocialPlugin.js